// extracted by mini-css-extract-plugin
export default {"rays":"sun_rays__3LG7R","rotating":"sun_rotating__3p-2n"};